import { render, staticRenderFns } from "./ManageSchoolSchedules.vue?vue&type=template&id=4feaf55d&scoped=true"
import script from "./ManageSchoolSchedules.vue?vue&type=script&lang=js"
export * from "./ManageSchoolSchedules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feaf55d",
  null
  
)

export default component.exports